import { KeyboardEvent, useId } from 'react';
import './styles.css';

type CheckBoxProps = {
	labelForChecked: string,
	labelForNotChecked: string,
	handleCheck: () => void,
	checked: boolean
}; 

const CheckBox = ({ labelForNotChecked, labelForChecked, checked, handleCheck, ...props }: React.HTMLAttributes<HTMLDivElement> & React.AriaAttributes & CheckBoxProps): JSX.Element => {
	const labelId = useId();

	const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
		if(e.key === ' ')
			handleCheck()
	}

	console.debug(props)

	return (
		<div 
			{...props}
			className='checkbox-wrapper'
			onClick={() => handleCheck()} 
			onKeyDown={ (e) => handleKeyDown(e)}
			id={labelId}
			role='checkbox' 
			aria-checked={checked} 
			tabIndex={0}
		>
			<div 
				className='checkbox'
			>
				<div className='checkbox-inner' />
			</div>
			<label 
				htmlFor={labelId} 
				className='checkbox-label'
			>
				{checked? labelForChecked: labelForNotChecked}
			</label>
		</div>
	);
}

export default CheckBox;